import {
  FECH_MERCHANT_BANKS,
  FECH_MERCHANT_BANKS_FAILED,
  FECH_MERCHANT_BANKS_SUCESS,
  FECH_SETTLEMENT_TIMES_FAILED,
  FECH_SETTLEMENT_TIMES,
  FECH_SETTLEMENT_TIMES_SUCESS,
  UPDATE_ASYNC_START,
  USER_PROFILE,
  UPDATE_PRIMARY_ACCOUNT,
  UPDATE_PRIMARY_ACCOUNT_SUCCESS,
  UPDATE_PRIMARY_ACCOUNT_FAILED,
  DELETE_ACCOUNT,
  DELETE_ACCOUNT_SUCCESS,
  DELETE_ACCOUNT_FAILED,
  FETCH_BANK_DETAILS,
} from '../types';
import Profile from 'services/profile';
import { showToast } from './toast';
import Settlement from 'services/settlement';
export const getMerchantProfile = () => async (dispatch, getState) => {
  dispatch({
    type: UPDATE_ASYNC_START,
  });
  try {
    const {
      common: { user },
    } = getState();

    const result = await Profile.fetchMerchantProfile(user.merchantUser.userId);
    dispatch({
      type: USER_PROFILE,
      payload: result.data,
    });
  } catch (error) {
    dispatch(
      showToast('error', error.response?.message || 'Error fetching  data.'),
    );
  }
};

export const updateProfile = (data) => async (dispatch, getState) => {
  dispatch({
    type: UPDATE_ASYNC_START,
    payload: false,
  });
  try {
    const {
      settings: { profile },
    } = getState();
    const response = await Profile.updateMerchantProfile(profile.userId, data);
    dispatch({
      type: USER_PROFILE,
      payload: response.data,
    });
    dispatch(
      showToast('success', response.message || 'Profile update successful'),
    );
  } catch (error) {
    dispatch(
      showToast(
        'error',
        'Something went wrong.',
        error.response?.message || 'Error updating profile.',
      ),
    );
  }
};

export const updateBusiness = (data) => async (dispatch, getState) => {
  dispatch({
    type: UPDATE_ASYNC_START,
    payload: false,
  });
  try {
    const {
      settings: { profile },
    } = getState();
    const response = await Profile.updateMerchantBusiness(
      profile.merchant.id,
      data,
    );
    dispatch({
      type: USER_PROFILE,
      payload: { ...profile, merchant: response.data },
    });
    dispatch(
      showToast('success', response.message || 'Business update successful'),
    );
  } catch (error) {
    dispatch(
      showToast(
        'error',
        'Something went wrong.',
        error.response?.message || 'Error updating business.',
      ),
    );
  }
};

export const fetchMerchantBanks =
  (merchantId) => async (dispatch, getState) => {
    dispatch({
      type: FECH_MERCHANT_BANKS,
    });
    try {
      const response = await Settlement.fetchMerchantBanks(merchantId);
      dispatch({
        type: FECH_MERCHANT_BANKS_SUCESS,
        payload: response.data.list,
      });
    } catch (error) {
      dispatch({
        type: FECH_MERCHANT_BANKS_FAILED,
      });
      dispatch(
        showToast(
          'error',
          'Something went wrong.',
          error.response?.message || 'Error fetching  data.',
        ),
      );
    }
  };

export const updatePrimaryAccount = (payload) => (dispatch, getState) => {
  dispatch({
    type: UPDATE_PRIMARY_ACCOUNT,
  });
  const {
    settings: { profile },
  } = getState();
  Settlement.updatePrimaryAccount(payload)
    .then((response) => {
      dispatch({
        type: UPDATE_PRIMARY_ACCOUNT_SUCCESS,
      });
      dispatch(fetchMerchantBanks(profile.merchant.id));
      dispatch(
        showToast(
          'success',
          response.message || 'Primary Account updated successfully',
        ),
      );
    })
    .catch((error) => {
      dispatch({
        type: UPDATE_PRIMARY_ACCOUNT_FAILED,
      });
      dispatch(
        showToast(
          'error',
          'Something went wrong.',
          error.response?.message || 'TError fetching  data.',
        ),
      );
    });
};

export const deleteAccount = (payload) => (dispatch, getState) => {
  dispatch({
    type: DELETE_ACCOUNT,
  });
  const {
    settings: { profile },
  } = getState();
  Settlement.deleteAccount(payload)
    .then((response) => {
      dispatch({
        type: DELETE_ACCOUNT_SUCCESS,
      });
      dispatch(fetchMerchantBanks(profile.merchant.id));
      dispatch(
        showToast(
          'success',
          response.message || 'Bank Account deleted successfully',
        ),
      );
    })
    .catch((error) => {
      dispatch({
        type: DELETE_ACCOUNT_FAILED,
      });
      dispatch(
        showToast(
          'error',
          'Something went wrong.',
          error.response?.message || 'TError fetching  data.',
        ),
      );
    });
};

export const fetchSettlementTimesSetting =
  (merchantId) => async (dispatch, getState) => {
    dispatch({
      type: FECH_SETTLEMENT_TIMES,
    });
    try {
      const response = await Settlement.fetchSettlementTimesSetting(merchantId);
      dispatch({
        type: FECH_SETTLEMENT_TIMES_SUCESS,
        payload: response.data,
      });
    } catch (error) {
      dispatch({
        type: FECH_SETTLEMENT_TIMES_FAILED,
      });
    }
  };

export const getMerchantBankDetails = () => async (dispatch, getState) => {
  try {
    const {
      common: { user },
    } = getState();

    const result = await Profile.fetchBankDetails(user.merchantId);
    dispatch({
      type: FETCH_BANK_DETAILS,
      payload: result.data,
    });
  } catch (error) {
    dispatch(
      showToast('error', error.response?.message || 'Error fetching  data.'),
    );
  }
};
